module.exports = __webpack_public_path__ + "assets/img/head1-en.30223e31.png";